import { getRuntimeConfig } from '~/shared/utils/config';
import { cloudflareLoader } from './cloudflareLoader';
import { defaultLoader } from './defaultLoader';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';

export function resolveImageLoader(src: string | StaticImport) {
    const {
        config: { NEXT_PUBLIC_CLOUDFLARE_LOADER_URL },
    } = getRuntimeConfig();

    const srcStr = typeof src === 'string' ? src : '';
    const isStatic = !/^https?:\/\//.test(srcStr);
    const isSvg = srcStr.includes('.svg');

    if (isStatic) return undefined;
    if (isSvg) return defaultLoader;
    if (NEXT_PUBLIC_CLOUDFLARE_LOADER_URL) return cloudflareLoader;

    return defaultLoader;
}
